import React, { useState } from "react";
import { EllipsisVertical, Copy, Calendar, FileText, ClipboardCopy } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

interface Props {
  onAction: (action: "edit" | "delete" | "copy" | "copyJson" | "fetchDates" | "sanitizeHtml") => void;
  variation?: { dataFetchUrl?: string };
  isWelcomeScreen?: boolean;
}

export const AgeGroupVariationActions: React.FC<Props> = ({ onAction, variation, isWelcomeScreen }) => {
  const [open, setOpen] = useState(false);
  const { userProfile } = useAuth();
  const isAdmin = userProfile?.role === 'admin_user';
  const hasDataFetchUrl = variation?.dataFetchUrl && variation.dataFetchUrl.trim().length > 0;

  return (
    <div className="relative">
      <button
        aria-label="Actions"
        className="hover:bg-accent rounded-full p-1 transition-colors"
        onClick={() => setOpen(o => !o)}
        tabIndex={0}
        type="button"
      >
        <EllipsisVertical size={20} />
      </button>
      {open && (
        <div className="absolute right-0 top-7 bg-white border rounded shadow-lg min-w-[150px] z-10">
          <button
            className="w-full text-left px-4 py-2 hover:bg-accent"
            onClick={() => { onAction("edit"); setOpen(false); }}
            type="button"
          >Edit</button>
          <button
            className="w-full text-left px-4 py-2 hover:bg-accent"
            onClick={() => { onAction("copy"); setOpen(false); }}
            type="button"
          ><div className="flex items-center gap-2">
              <Copy size={16} />
              <span>Copy</span>
            </div></button>
          {isAdmin && (
            <button
              className="w-full text-left px-4 py-2 hover:bg-accent flex items-center gap-2"
              onClick={() => { onAction("copyJson"); setOpen(false); }}
              type="button"
            >
              <ClipboardCopy size={16} />
              <span>Copy to clipboard</span>
            </button>
          )}
          {isAdmin && hasDataFetchUrl && !isWelcomeScreen && (
            <button
              className="w-full text-left px-4 py-2 hover:bg-accent text-blue-600"
              onClick={() => { onAction("fetchDates"); setOpen(false); }}
              type="button"
            >
              <div className="flex items-center gap-2">
                <Calendar size={16} />
                <span>Fetch session dates</span>
              </div>
            </button>
          )}
          {isAdmin && hasDataFetchUrl && !isWelcomeScreen && (
            <button
              className="w-full text-left px-4 py-2 hover:bg-accent text-green-600"
              onClick={() => { onAction("sanitizeHtml"); setOpen(false); }}
              type="button"
            >
              <div className="flex items-center gap-2">
                <FileText size={16} />
                <span>Sanitize HTML</span>
              </div>
            </button>
          )}
          <button
            className="w-full text-left px-4 py-2 hover:bg-accent text-red-600"
            onClick={() => { onAction("delete"); setOpen(false); }}
            type="button"
          >Delete</button>
        </div>
      )}
    </div>
  );
};
